import { render, staticRenderFns } from "./beforeLeavePhysical.vue?vue&type=template&id=6fd1bd96&"
import script from "./beforeLeavePhysical.vue?vue&type=script&lang=js&"
export * from "./beforeLeavePhysical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports